<!--
 * @Description: 
 * @Author: 山淑兰
 * @Date: 2019-09-06 15:12:11
 * @LastEditTime: 2020-07-08 10:52:26
 * @LastEditors: 山淑兰
 -->

<template>
	<div class="meeting">
		<MeetHead :bannerList="bannerEntityListData"></MeetHead>
		<div class="navfloat">
			<div class="navs" v-if="navShow">
				<a :href="homeUrl" target="_top">首页</a>
				> <a @click="goIndex()">日程列表</a>
			</div>
			<div class="nav-search">
				<SearchNew v-if="searchShow" :pupopData="selectPopupData" :languageShow="languageShow"></SearchNew>
			</div>
		</div>
		<main>
			<!-- 被缓存的组件渲染 -->
			<keep-alive>
				<router-view v-if="$route.meta.keepAlive" @searchDatas="handlerParmes" :introShow="introShow"
					@BannerEntityList="getBannerEntityList"></router-view>
			</keep-alive>
			<!--未被缓存的组件 -->
			<router-view v-if="!$route.meta.keepAlive" @searchDatas="handlerParmes" :selectData="selectData"
				:introShow="introShow" @BannerEntityList="getBannerEntityList"></router-view>
		</main>
		<Nav v-if="fNavShow"></Nav>
		<Footer v-if="footerShow" :footInfo="this.footInfo"></Footer>
	</div>
</template>
<script>
	import MeetHead from './components/common/MeetHeads'
	import SearchNew from './components/common/SearchNews.vue'
	import Nav from './components/common/navigation.vue'
	import Footer from '@components/Footer'
	// import commonJS from '../../lib/signUp.js'

	export default {
		neme: 'meeting',
		data() {
			return {
				show: false,
				searchShow: true,
				footerShow: true,
				selectPopupData: {},
				bannerEntityListData: {},
				selectData: '',
				navShow: true,
				homeUrl: '',
				locationUrl: '',
				fNavShow: true,
				languageShow: true,
				introShow: true,
				footInfo: {
					LogoTxt: '',
					LogoLink: '',
					LogoImg: '',
				},
			}
		},
		components: {
			MeetHead,
			SearchNew,
			Nav,
			Footer,
		},
		created() {
			if (this.$route.query.red == 'all') {
				this.searchShow = false
				this.footerShow = false
			}
			this.init();

		},
		// created() {
		//   let isMobile = new commonJS().isMobile()
		//   if (!isMobile) {
		//     let _params = window.location.href.split('?')[1]
		//     _params = _params.replace('&dateid=0', '')
		//     window.location.href = `https://mp.weiqihd.com/pweb/#/schedules?${_params}`
		//   }
		// },
		methods: {
			async init() {
				try {
					const params = {
						m: this.$route.query.m
					};
					const res = await this.$http.initMeetingInfo(params);
					console.log(res)
					this.footInfo.LogoTxt = res.LogoTxt
					this.footInfo.LogoLink = res.LogoLink
					this.footInfo.LogoImg = res.LogoImg
					this.languageShow = res.whetchinen == 0 ? false : true
					this.introShow = res.isshowintrod == 0 ? true : false
					if (res.isshowlogo === 1) {
						this.footerShow = false
					} else {
						this.footerShow = true
					}
					if (res.HomeUrl == null || res.HomeUrl == '') {
						this.navShow = false
					} else {
						this.navShow = true
						this.homeUrl = res.HomeUrl
					}
				} catch (error) {
					console.error(error);
				}
			},
			handlerParmes(val) {
				this.selectPopupData = val
			},
			getBannerEntityList(val) {
				console.log(val)
				this.bannerEntityListData = val
				// this.bannerEntityListData = [
				//   {
				//       "imgPath": "https://img.weiqihd.com//File/Image/20210317/20210317202657_0573.png",
				//       "imgLink": null
				//   },{
				//       "imgPath": "https://img.weiqihd.com//File/Image/20210317/20210317202657_0573.png",
				//       "imgLink": "https://www.baidu.com/"
				//   }
				// ]
			},
			goIndex() {
				if (this.$route.path == '/mpro/place' && !this.$route.query.dateid) {
					//this.activeShow = true
				} else {
					const params = {
						m: this.$route.query.m
					}
					this.$router.push({
						path: 'place',
						query: params,
					})
				}
			},
		},
	}
</script>
<style lang="scss" scoped>
	.meeting {
		padding-bottom: 40px;

	}

	.navfloat {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 392px;
	}

	.navs {
		position: absolute;
		left: 0;
		top: 30px;
		right: 0;
		height: 40px;
		font-size: 26px;
		line-height: 40px;
		background: url(../../assets/home.png) no-repeat 20px center;
		background-size: 30px 30px;
		color: #fff;
		padding: 0 30px 0 60px;

		a {
			color: #fff;
		}
	}

	.nav-search {
		position: absolute;
		top: 90px;
		left: 20px;
		right: 20px;
	}

	.loading {
		width: 100%;
		margin-top: 20%;

		>div {
			width: 200px;
			background: #ddd;
			margin: 0 auto;
			padding: 40px 0;
			border-radius: 10px;
		}
	}

	.van-notify {
		font-size: 28px;
		line-height: 2rem;
		background-color: #fa4e1a;
	}
</style>
